var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF6301",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3496 20.0005C11.3496 22.2948 12.261 24.4952 13.8834 26.1176C15.5057 27.7399 17.7061 28.6514 20.0005 28.6514C22.2948 28.6514 24.4952 27.7399 26.1176 26.1176C27.7399 24.4952 28.6514 22.2948 28.6514 20.0005C28.6514 17.7061 27.7399 15.5057 26.1176 13.8834C24.4952 12.261 22.2948 11.3496 20.0005 11.3496C17.7061 11.3496 15.5057 12.261 13.8834 13.8834C12.261 15.5057 11.3496 17.7061 11.3496 20.0005Z",
    stroke: "#FF6301",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 24.3254V20",
    stroke: "#FF6301",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 15.6758C19.8937 15.6758 19.7892 15.7075 19.7003 15.7669C19.6113 15.8263 19.542 15.9108 19.5011 16.0096C19.4602 16.1083 19.4495 16.2171 19.4704 16.3219C19.4912 16.4268 19.5427 16.5232 19.6183 16.5988C19.6939 16.6744 19.7903 16.7259 19.8952 16.7468C20 16.7676 20.1088 16.7569 20.2076 16.716C20.3063 16.6751 20.3908 16.6058 20.4502 16.5168C20.5096 16.4279 20.5413 16.3234 20.5413 16.2165C20.5413 16.0731 20.4844 15.9355 20.383 15.8341C20.2816 15.7327 20.144 15.6758 20.0006 15.6758Z",
    fill: "#FF6301",
    stroke: "#FF6301",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarning);
export default __webpack_public_path__ + "static/media/toast-warning.ea82b51f4d7acafee5e8be45590402d5.svg";
export { ForwardRef as ReactComponent };